/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react"
import { Col, Modal, Row } from "react-bootstrap"
import { Button, DropDown, Input } from "../../../components"
import BootstrapSelect from "react-bootstrap-select-dropdown";
import { WEEK_DAYS } from "../../../utilities/utils";
import { GetCourtsAvailableForAssociateBooking, GetSlotsForAssociateBooking } from "../../../utilities/api/courts";
import { toast } from "react-toastify";
import { AssociateRescheduleAddBookingSlots } from "../../../utilities/api/associateBooking";
import { messages } from "../../../utilities/Messages";
const getMessage = messages.associateBooking;

const AssociateRescheduleAddMoreDaysModal = (props: any) => {
    const { showAddModal, handleCloseAdd, StartDate, bookingDetails, GetData } = props
    const [bookingDay, setBookingDay] = useState("")
    const [slotsList, setSlotsList] = useState([]) as any
    const [courtList, setCourtList] = useState([]) as any
    const [selectedSlot, setSelectedSlot] = useState([]) as any
    const [selectedCourt, setSelectedCourt] = useState([]) as any
    const [addButton, setAddButton] = useState(false)

    const GetSlots = async () => {
        let startDate = StartDate().split("/").reverse().join("-")
        let endDate = bookingDetails.endDate.split("/").reverse().join("-")
        if (new Date(endDate) > new Date(startDate)) {
            const result = await GetSlotsForAssociateBooking(startDate, endDate, bookingDetails.facilityId, bookingDetails.sportId)
            if (result.statusCode === 200) {
                setSlotsList(result?.data?.timeSlots)
            }
        }
    }

    useEffect(() => {
        GetSlots()
    }, [])

    const GetCourts = async () => {
        let payload = {
            facilityId: Number(bookingDetails.facilityId),
            sportId: Number(bookingDetails.sportId),
            startDate: StartDate().split("/").reverse().join("-"),
            endDate: bookingDetails.endDate.split("/").reverse().join("-"),
            slots: selectedSlot.map((item: any) => ({
                sessionDay: bookingDay,
                "startTime": item.fromTime,
                "endTime": item.toTime
            }))
        }
        const result = await GetCourtsAvailableForAssociateBooking(payload)
        if (result.status === 200) {
            setCourtList(result.data.data.rows?.map((item: any) => ({
                labelKey: item.id,
                value: item.name
            })
            ))
            !result.data.data.rows.length && toast.error(getMessage.court_isUnavailable)
        }
    }

    useEffect(() => {
        selectedSlot.length && bookingDay && GetCourts()
    }, [selectedSlot, bookingDay])

    const handleChecked = (checked: boolean, data: any) => {
        checked
            ? setSelectedSlot([...selectedSlot, data])
            : setSelectedSlot(selectedSlot?.filter((item: any) => item.fromTime !== data.fromTime))
    }

    const handleChange = (value: any) => {
        setSelectedCourt(value.selectedKey)
    }

    const AddBookingSlots = async () => {
        setAddButton(true)
        let payload = {
            selectedSlots: selectedSlot.map((item: any) => (
                {
                    bookingDay: bookingDay,
                    startTime: item.fromTime,
                    endTime: item.toTime,
                    courts: selectedCourt
                }
            ))
        }
        let _AddBookingSlots = await AssociateRescheduleAddBookingSlots(bookingDetails.id, payload)
        if (_AddBookingSlots?.status === 200) {
            GetData()
            handleCloseAdd()
            toast.success(_AddBookingSlots?.data.message)
        } else {
            toast.error(_AddBookingSlots?.response.data.message);
        }
        setAddButton(false)
    }

    return (
        <Modal aria-labelledby="contained-modal-title-vcenter"
            centered show={showAddModal} onHide={handleCloseAdd} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Add More Days</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="slot-selection">
                    <Row>
                        <Col lg={4}>
                            <div className="mb-3 text-start">
                                <label htmlFor="day" className="form-label">
                                    Select Day
                                </label>
                                <DropDown
                                    className="form-control"
                                    id="day"
                                    name="day"
                                    onChange={(e: any) =>
                                        setBookingDay(e?.target?.value)
                                    }
                                    value={bookingDay}
                                >
                                    <option>Select Day</option>
                                    {WEEK_DAYS.map((_day: any) => {
                                        return (
                                            <option key={_day}>{_day}</option>
                                        )
                                    })}
                                </DropDown>
                            </div>
                        </Col>

                        <Col lg={12}>
                            <label htmlFor="" className="form-label">Available Slots</label>
                            <div className="overflow-auto mb-3" style={{ height: "245px" }}>
                                <div className="available-slot d-flex flex-wrap gap-2 ">
                                    {slotsList.length ? slotsList?.map((item: any, index: number) => {
                                        return (
                                            <span style={{ width: '110px' }} key={"check" + index}>
                                                <Input onChange={(e: any) => handleChecked(e.target.checked, item)}
                                                    checked={selectedSlot?.find((elem: any) => elem.fromTime === item.fromTime) ? true : false}
                                                    id={"slot" + index} type="checkbox" name={"slot" + index} className="btn-check" />
                                                <label htmlFor={"slot" + index} className="bg-light bg-opacity-50 border border-2 btn btn-sm p-1 w-100">
                                                    <div className="slot-box text-start">
                                                        <span className="d-block">{item?.fromTime} to {item?.toTime}</span>
                                                        <span className="text-primary"><span className="rupees-symbol">&#8377;</span> {item?.ratePerSlot}</span>
                                                        {item?.discountPercent &&
                                                            <>
                                                                <del><span><span className="rupees-symbol">&#8377;</span> {item.actualRatePerSlot}</span></del>
                                                            </>
                                                        }
                                                    </div>
                                                </label>
                                            </span>
                                        )
                                    })
                                        : <tr>
                                            <td colSpan={5} className="text-danger">
                                                No Slots Available
                                            </td>
                                        </tr>
                                    }
                                </div>
                            </div>
                        </Col>
                        <Col lg={4}>
                            <div className="mb-3 text-start">
                                <label htmlFor="courts" className="form-label">
                                    Select Court{" "}
                                </label>
                                <BootstrapSelect
                                    className="form-select-custom form-control"
                                    selectStyle=""
                                    actionBtnStyle="btn-outline-primary"
                                    options={courtList}
                                    isMultiSelect={true}
                                    showTick={true}
                                    showAction={true}
                                    placeholder="Select Courts"
                                    onChange={handleChange}
                                    disabled={!bookingDay || selectedSlot.length === 0}
                                />
                            </div>
                        </Col>
                    </Row>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={AddBookingSlots} disabled={!bookingDay || selectedSlot.length === 0 || selectedCourt.length === 0 || addButton} type="button" bname={addButton ? "Adding" : "Add"} name="addslot" id="addslot" className="btn btn-primary rounded-1"></Button>
            </Modal.Footer>
        </Modal>
    )
}

export { AssociateRescheduleAddMoreDaysModal }
